import { Alert, Stack } from '@mantine/core';
import type { FC } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import { ImageUpload } from '../../../components/form/ImageUpload.tsx';
import { useI18n } from '../../../hooks/useI18n.ts';
import type { IncompleteEventFormComplete } from '../IncompleteEventForm/schema.ts';

export const CoverImage: FC<{
  useFormValue: UseFormReturn<IncompleteEventFormComplete>;
}> = ({ useFormValue: { control } }) => {
  const { t } = useI18n();

  return (
    <Stack gap="xs" pos="relative">
      <Alert color="gigi-aqua" p="xs" radius="xs">
        {t('event-form_artwork_message') ??
          'Make your event stand out on gogigi.com. Use high-quality artwork. Explicit content or images will be reviewed.'}
      </Alert>

      <ImageUpload control={control} name="image" />
    </Stack>
  );
};
